import { ROUTE_CONSTANT } from "./route-constants";
import Quiz from "../pages/quiz";
import Login from "../pages/login";
import SignUp from "../pages/signup";
import Plan from "../pages/plan";
import Checkout from "../pages/checkout";
import Confirmation from "../pages/confirmation";
import Dashboard from "../pages/dashboard";
import ForgotPassword from "../pages/forgot-password/";
import ResetPassword from "../pages/reset-password";
import Settings from "../pages/settings";
import Processor from "../pages/processor";
import CareerPrecontent from "../pages/career-precontent";

import SignOut from "../pages/sign-out/";
import AdminLogin from "../pages/admin-login";
import AdminSearch from "../pages/admin-search";
import QuizB from "../pages/quiz-b";
import LoginAsAdmin from "../pages/login-as-admin";

import PersonalityReport from "../pages/personality-report";
import CareerReport from "../pages/career-report";

import BigFiveReport from "../pages/big-five-report/";
import BigFiveFacetsReport from "../pages/big-five-facets-report";
import EnneagramReport from "../pages/enneagram-report";
import LikeabilityReport from "../pages/likeability-report";
import PersonalityDisorderReport from "../pages/personality-disorder-report";
import DiscPersonalityReport from "../pages/disc-personality-report";
import ADHDReport from "../pages/adhd-report/component";
import CareerPreferenceReport from "../pages/career-preference-report";
import EmotionalIntelligenceReport from "../pages/emotional-intelligence-report";
import DifficultPersonReport from "../pages/difficult-person-report";
import AutismSpectrumReport from "../pages/autism-spectrum-report";
import HighlySensitivePersonReport from "../pages/highly-sensitive-person-report";
import AttachmentStyleReport from "../pages/attachment-style-report";
import CheckoutB from "../pages/checkout-b";
import DyslexiaScreeningChildrenReport from "../pages/dyslexia-screening-children-report";
import DyslexiaScreeningAdultReport from "../pages/dyslexia-screening-adult-report";
import LoveStyleReport from "../pages/love-style-report";
import NarcissisticPersonalityDisorderReport from "../pages/narcissistic-personality-disorder-report";
import AntisocialPersonalityDisorderReport from "../pages/antisocial-personality-disorder-report";
import CareerPreferencePrecontent from "../pages/career-preference-precontent";
import FourTemperamentPersonalityReport from "../pages/four-temperaments-personality-report";
import CareerPreferenceReportV2 from "../pages/career-preference-report-v2";
import RomanticPersonalizedReport from "../pages/romantic-personalized-report";
import RomanticCompatibilityReport from "../pages/romantic-compatibility-report";
import ColorBlindReport from "../pages/color-blind-report";
import DepressionReport from "../pages/depression-report";
import BipolarDisorderReport from "../pages/bipolar-disorder-report";
import CheckoutC from "../pages/checkout-c";
import NotFound from "../pages/not-found";
import DashboardB from "../pages/dashboard-b";

export const ComponentList = {
  RootHome: {
    Component: <Quiz />,
    Path: ROUTE_CONSTANT.ROOT_HOME,
    //LocalePath: ROUTE_CONSTANT.ROOT_HOME_LOCALE,
  },
  Quiz: {
    Component: <Quiz />,
    Path: ROUTE_CONSTANT.QUIZ,
    LocalePath: ROUTE_CONSTANT.QUIZ_LOCALE,
    //LocalePath: ROUTE_CONSTANT.HOME_LOCALE,
  },
  QuizB: {
    Component: <QuizB />,
    Path: ROUTE_CONSTANT.QUIZ_B,
    LocalePath: ROUTE_CONSTANT.QUIZ_B_LOCALE,
    //LocalePath: ROUTE_CONSTANT.HOME_LOCALE,
  },
  // SignOut: {
  //   Component: <SignOut />,
  //   Path: ROUTE_CONSTANT.SIGNOUT,
  //   // LocalePath: ROUTE_CONSTANT.SIGNOUT_LOCALE,
  // },
  Login: {
    Component: <Login />,
    Path: ROUTE_CONSTANT.LOGIN,
    LocalePath: ROUTE_CONSTANT.LOGIN_LOCALE,
    // LocalePath: ROUTE_CONSTANT.SIGNIN_LOCALE,
  },
  SignUp: {
    Component: <SignUp />,
    Path: ROUTE_CONSTANT.SIGNUP,
    LocalePath: ROUTE_CONSTANT.SIGNUP_LOCALE,
    // LocalePath: ROUTE_CONSTANT.SIGNUP_LOCALE,
  },
  // Language: {
  //   Component: <Language />,
  //   Path: ROUTE_CONSTANT.LANGUAGE,
  //   LocalePath: ROUTE_CONSTANT.LANGUAGES_LOCALE,
  // },

  Plan: {
    Component: <Plan />,
    Path: ROUTE_CONSTANT.PAYMENT_PLAN,
    LocalePath: ROUTE_CONSTANT.PAYMENT_PLAN_LOCALE,
  },
  ResetPassword: {
    Component: <ResetPassword />,
    Path: ROUTE_CONSTANT.RESET_PASSWORD,
    LocalePath: ROUTE_CONSTANT.RESET_PASSWORD_LOCALE,
  },
  ForgotPassword: {
    Component: <ForgotPassword />,
    Path: ROUTE_CONSTANT.FORGOT_PASSWORD,
    LocalePath: ROUTE_CONSTANT.FORGOT_PASSWORD_LOCALE,
  },

  Confirmation: {
    Component: <Confirmation />,
    Path: ROUTE_CONSTANT.CONFIRMATION,
    LocalePath: ROUTE_CONSTANT.CONFIRMATION_LOCALE,
  },
  Checkout: {
    Component: <Checkout />,
    Path: ROUTE_CONSTANT.CHECKOUT,
    LocalePath: ROUTE_CONSTANT.CHECKOUT_LOCALE,
  },
  CheckoutB: {
    Component: <CheckoutB />,
    Path: ROUTE_CONSTANT.CHECKOUT_B,
    LocalePath: ROUTE_CONSTANT.CHECKOUT_B_LOCALE,
  },

  CheckoutC: {
    Component: <CheckoutC />,
    Path: ROUTE_CONSTANT.CHECKOUT_C,
    LocalePath: ROUTE_CONSTANT.CHECKOUT_C_LOCALE,
  },

  Settings: {
    Component: <Settings />,
    Path: ROUTE_CONSTANT.SETTINGS,
    LocalePath: ROUTE_CONSTANT.SETTINGS_LOCALE,
  },

  Report: {
    Component: <PersonalityReport />,
    Path: ROUTE_CONSTANT.PERSONALITY_REPORT,
    LocalePath: ROUTE_CONSTANT.PERSONALITY_REPORT_LOCALE,
  },

  Dashboard: {
    Component: <Dashboard />,
    Path: ROUTE_CONSTANT.DASHBOARD,
    LocalePath: ROUTE_CONSTANT.DASHBOARD_LOCALE,
  },
  DashboardB: {
    Component: <DashboardB />,
    Path: ROUTE_CONSTANT.DASHBOARD_B,
    LocalePath: ROUTE_CONSTANT.DASHBOARD_B_LOCALE,
  },

  Processor: {
    Component: <Processor />,
    Path: ROUTE_CONSTANT.PROCCESOR,
    // LocalePath: ROUTE_CONSTANT.DASHBOARD_LOCALE,
  },
  CareerPreContent: {
    Component: <CareerPrecontent />,
    Path: ROUTE_CONSTANT.CAREER_PRE_CONTENT,
    LocalePath: ROUTE_CONSTANT.CAREER_PRE_CONTENT_LOCALE,
  },

  CareerViewResult: {
    Component: <CareerReport />,
    Path: ROUTE_CONSTANT.CAREER_REPORT,
    LocalePath: ROUTE_CONSTANT.CAREER_REPORT_LOCALE,
  },

  SignOut: {
    Component: <SignOut />,
    Path: ROUTE_CONSTANT.SIGNOUT,
  },

  AdminLogin: {
    Component: <AdminLogin />,
    Path: ROUTE_CONSTANT.ADMIN_LOGIN,
  },

  LoginAsAdmin: {
    Component: <LoginAsAdmin />,
    Path: ROUTE_CONSTANT.LOGIN_AS_ADMIN,
  },

  AdminSearch: {
    Component: <AdminSearch />,
    Path: ROUTE_CONSTANT.ADMIN_SEARCH,
  },

  BigFiveReport: {
    Component: <BigFiveReport />,
    Path: ROUTE_CONSTANT.BIG_FIVE_REPORT,
    LocalePath: ROUTE_CONSTANT.BIG_FIVE_REPORT_LOCALE,
  },
  BigFiveFacetsReport: {
    Component: <BigFiveFacetsReport />,
    Path: ROUTE_CONSTANT.BIG_FIVE_FACETS_REPORT,
    LocalePath: ROUTE_CONSTANT.BIG_FIVE_FACETS_REPORT_LOCALE,
  },
  EnneagramReport: {
    Component: <EnneagramReport />,
    Path: ROUTE_CONSTANT.ENNEAGRAM_REPORT,
    LocalePath: ROUTE_CONSTANT.ENNEAGRAM_REPORT_LOCALE,
  },

  LikeabilityReport: {
    Component: <LikeabilityReport />,
    Path: ROUTE_CONSTANT.LIKEABILITY_REPORT,
    LocalePath: ROUTE_CONSTANT.LIKEABILITY_REPORT_LOCALE,
  },

  PersonalityDisorderReport: {
    Component: <PersonalityDisorderReport />,
    Path: ROUTE_CONSTANT.PERSONALITY_DISORDER_REPORT,
    LocalePath: ROUTE_CONSTANT.PERSONALITY_DISORDER_REPORT_LOCALE,
  },
  DiscPersonalityReport: {
    Component: <DiscPersonalityReport />,
    Path: ROUTE_CONSTANT.DISC_PERSONALITY_REPORT,
    LocalePath: ROUTE_CONSTANT.DISC_PERSONALITY_REPORT_LOCALE,
  },
  ADHDReport: {
    Component: <ADHDReport />,
    Path: ROUTE_CONSTANT.ADHD_REPORT,
    LocalePath: ROUTE_CONSTANT.ADHD_REPORT_LOCALE,
  },
  CareerPreferenceReport: {
    Component: <CareerPreferenceReport />,
    Path: ROUTE_CONSTANT.CAREER_PREFERENCE_REPORT,
    LocalePath: ROUTE_CONSTANT.CAREER_PREFERENCE_REPORT_LOCALE,
  },
  CareerPreferenceReportV2: {
    Component: <CareerPreferenceReportV2 />,
    Path: ROUTE_CONSTANT.CAREER_PREFERENCE_REPORT_V2,
    LocalePath: ROUTE_CONSTANT.CAREER_PREFERENCE_REPORT_V2_LOCALE,
  },
  EmotionalIntelligenceReport: {
    Component: <EmotionalIntelligenceReport />,
    Path: ROUTE_CONSTANT.EMOTIONAL_INTELLIGENCE_REPORT,
    LocalePath: ROUTE_CONSTANT.EMOTIONAL_INTELLIGENCE_REPORT_LOCALE,
  },

  DifficultPersonReport: {
    Component: <DifficultPersonReport />,
    Path: ROUTE_CONSTANT.DIFFICULT_PERSON_REPORT,
    LocalePath: ROUTE_CONSTANT.DIFFICULT_PERSON_REPORT_LOCALE,
  },

  AutismSpectrumReport: {
    Component: <AutismSpectrumReport />,
    Path: ROUTE_CONSTANT.AUTISM_SPECTRUM_REPORT,
    LocalePath: ROUTE_CONSTANT.AUTISM_SPECTRUM_REPORT_LOCALE,
  },

  HighlySensitivePersonReport: {
    Component: <HighlySensitivePersonReport />,
    Path: ROUTE_CONSTANT.HIGHLY_SENSITIVE_PERSON_REPORT,
    LocalePath: ROUTE_CONSTANT.HIGHLY_SENSITIVE_PERSON_REPORT_LOCALE,
  },

  AttachmentStyleReport: {
    Component: <AttachmentStyleReport />,
    Path: ROUTE_CONSTANT.ATTACHMENT_STYLE_REPORT,
    LocalePath: ROUTE_CONSTANT.ATTACHMENT_STYLE_REPORT_LOCALE,
  },

  DyslexiaScreeningChildrenReport: {
    Component: <DyslexiaScreeningChildrenReport />,
    Path: ROUTE_CONSTANT.DYSLEXIA_SCREENING_CHILDREN_REPORT,
    LocalePath: ROUTE_CONSTANT.DYSLEXIA_SCREENING_CHILDREN_REPORT_LOCALE,
  },

  DyslexiaScreeningAdultReport: {
    Component: <DyslexiaScreeningAdultReport />,
    Path: ROUTE_CONSTANT.DYSLEXIA_SCREENING_ADULT_REPORT,
    LocalePath: ROUTE_CONSTANT.DYSLEXIA_SCREENING_ADULT_REPORT_LOCALE,
  },

  LoveStyleReport: {
    Component: <LoveStyleReport />,
    Path: ROUTE_CONSTANT.LOVE_STYLE_REPORT,
    LocalePath: ROUTE_CONSTANT.LOVE_STYLE_REPORT_LOCALE,
  },

  NarcissisticPersonalityDisorder: {
    Component: <NarcissisticPersonalityDisorderReport />,
    Path: ROUTE_CONSTANT.NARCISSISTIC_PERSONALITY_DISORDER_REPORT,
    LocalePath: ROUTE_CONSTANT.NARCISSISTIC_PERSONALITY_DISORDER_REPORT_LOCALE,
  },

  AntisocialPersonalityDisorder: {
    Component: <AntisocialPersonalityDisorderReport />,
    Path: ROUTE_CONSTANT.ANTISOCIAL_PERSONALITY_DISORDER_REPORT,
    LocalePath: ROUTE_CONSTANT.ANTISOCIAL_PERSONALITY_DISORDER_REPORT_LOCALE,
  },

  CareerPreferencePrecontent: {
    Component: <CareerPreferencePrecontent />,
    Path: ROUTE_CONSTANT.CAREER_PREFERENCE_PRE_CONTENT,
    LocalePath: ROUTE_CONSTANT.CAREER_PREFERENCE_PRE_CONTENT_LOCALE,
  },
  FourTemperamentPersonalityReport: {
    Component: <FourTemperamentPersonalityReport />,
    Path: ROUTE_CONSTANT.FOUR_TEMPERAMENT_PERSONALITY_REPORT,
    LocalePath: ROUTE_CONSTANT.FOUR_TEMPERAMENT_PERSONALITY_REPORT_LOCALE,
  },
  RomanticPersonalityReport: {
    Component: <RomanticPersonalizedReport />,
    Path: ROUTE_CONSTANT.ROMANTIC_PERSONALITY_REPORT,
    LocalePath: ROUTE_CONSTANT.ROMANTIC_PERSONALITY_REPORT_LOCALE,
  },

  RomanticCompatibilityReport: {
    Component: <RomanticCompatibilityReport />,
    Path: ROUTE_CONSTANT.ROMANTIC_COMPATIBILITY_REPORT,
    LocalePath: ROUTE_CONSTANT.ROMANTIC_COMPATIBILITY_REPORT_LOCALE,
  },

  ColorBlindReport: {
    Component: <ColorBlindReport />,
    Path: ROUTE_CONSTANT.COLOR_BLIND_REPORT,
    LocalePath: ROUTE_CONSTANT.COLOR_BLIND_REPORT_LOCALE,
  },

  DepressionReport: {
    Component: <DepressionReport />,
    Path: ROUTE_CONSTANT.DEPRESSION_REPORT,
    LocalePath: ROUTE_CONSTANT.DEPRESSION_REPORT_LOCALE,
  },

  BipolarDisorderReport: {
    Component: <BipolarDisorderReport />,
    Path: ROUTE_CONSTANT.BIPOLAR_DISORDER_REPORT,
    LocalePath: ROUTE_CONSTANT.BIPOLAR_DISORDER_REPORT_LOCALE,
  },

  NotFound: {
    Component: <NotFound />,
    Path: ROUTE_CONSTANT.NOT_FOUND,
    LocalePath: ROUTE_CONSTANT.NOT_FOUND_LOCALE,
  },

  // CancelSubscription: {
  //   Component: <CancelSubscription />,
  //   Path: ROUTE_CONSTANT.CANCEL_SUBSCRIPTION,
  //   LocalePath: ROUTE_CONSTANT.CANCEL_SUBSCRIPTION_LOCALE,
  // },
  // CancelSubscriptionConfirmation: {
  //   Component: <CancelSubscriptionConfirmation />,
  //   Path: ROUTE_CONSTANT.CANCEL_SUBSCRIPTION_CONFIRMATION,
  //   LocalePath: ROUTE_CONSTANT.CANCEL_SUBSCRIPTION_CONFIRMATION_LOCALE,
  // },
};
